import { AnimationComponent, Grid2, Show, Tab, Tabs } from "components";
import { PortfolioDetailsInterface } from "interfaces/Portfolio";
import {
  CommissionManager,
  FeeCalculation,
  FeeCollection,
  Invoice,
  Proforma,
} from "Pages/Revenue";
import { useParams } from "react-router-dom";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import useDocumentTitle from "utils/useDocumentTitle";
import RevenueDetailsTab from "./RevenueDetailsTab";

interface TabConfig {
  label: string;
  component: React.ComponentType<any>;
  props?: Record<string, any>;
}

interface Props {
  portfolioDetailData?: PortfolioDetailsInterface;
}

const PortfolioRevenue = (props: Props) => {
  useDocumentTitle("Portfolio Revenue");

  const { id } = useParams();

  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);
  const { tabOfPortfolioRevenue } = useAppSelector((state) => state?.app?.tab);

  const tabs: TabConfig[] = [
    {
      label: "Fee Plans & Metrics",
      component: RevenueDetailsTab,
      props: {
        portfolioId: id,
      },
    },
    {
      label: "Fee Calculation",
      component: FeeCalculation,
      props: {
        portfolioId: id,
        name: "portfolioCalculation",
        tableName: "portfolio_calculation",
      },
    },
    {
      label: "Proforma",
      component: Proforma,
      props: {
        portfolioId: id,
        name: "portfolioProforma",
        tableName: "portfolio_proforma",
      },
    },
    {
      label: "Invoice",
      component: Invoice,
      props: {
        portfolioId: id,
        name: "portfolioInvoice",
        tableName: "portfolio_invoice",
      },
    },
    {
      label: "Fee Collection",
      component: FeeCollection,
      props: {
        portfolioId: id,
        name: "portfolioFeeCollection",
        tableName: "portfolio_fee_collection",
        clientId: props?.portfolioDetailData?.client,
      },
    },
    {
      label: "Commission Manager",
      component: CommissionManager,
      props: {
        portfolioId: id,
        name: "portfolioCommission",
        tableName: "portfolio_commission",
        commissionLink: props.portfolioDetailData.partners.length
          ? `/app/revenue/commission/${props.portfolioDetailData.partners[0]}/invoices`
          : null,
        isButtonDisable: props.portfolioDetailData.partners.length === 0,
      },
    },
  ];

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12} display={"flex"}>
        <Tabs
          className="light"
          variant="standard"
          TabIndicatorProps={{ style: { display: "none" } }}
          onChange={(e, val) => {
            dispatch(TAB({ tabKey: "tabOfPortfolioRevenue", tabValue: val }));
          }}
          value={tabOfPortfolioRevenue}
        >
          {tabs
            .filter((dataItem) =>
              userData?.userRole !== UserRoleTypes.advisor
                ? dataItem.label !== "Fee Calculation"
                : dataItem,
            )
            .map((tab, index) => (
              <Tab key={index} label={tab.label} disableTouchRipple />
            ))}
        </Tabs>
      </Grid2>

      <Grid2 size={12}>
        {tabs.map((tab, index) => (
          <Show.When key={index} isTrue={tabOfPortfolioRevenue === index}>
            <AnimationComponent>
              <tab.component {...(tab?.props || {})} />
            </AnimationComponent>
          </Show.When>
        ))}
      </Grid2>
    </Grid2>
  );
};

export default PortfolioRevenue;
